import React from 'react';


interface SchemaMarkupProps {
    type: string;
    data: Record<string, any>;
}

/**
 * Reusable component to inject JSON-LD schema into the document head.
 * Uses a plain script tag since we might not have react-helmet set up fully,
 * or we can just append to head.
 * 
 * Note: If react-helmet-async is not available, we can use a direct portal or effect.
 * Given we use 'useSEO' hook which manipulates document directly, we can do similar here.
 * But for structured data, a simple component that renders nothing but has a side effect
 * or renders a script is common.
 */
const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ type, data }) => {
    const schema = {
        "@context": "https://schema.org",
        "@type": type,
        ...data
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    );
};

export default SchemaMarkup;
